import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { PawPrint, Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAF9F6]/80 border-b border-[#EAE4D9]/60"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2.5 group"
        >
          <span className="grid place-items-center h-10 w-10 rounded-full bg-[#D96B43] text-white transition-transform duration-300 group-hover:-rotate-12">
            <PawPrint size={20} strokeWidth={1.75} />
          </span>
          <span className="font-serif text-2xl font-semibold tracking-tight text-[#2C3529]">
            PawJournal
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-sans text-sm font-medium uppercase tracking-wider transition-colors ${
                  isActive ? "text-[#D96B43]" : "text-[#2C3529] hover:text-[#D96B43]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/blog"
            data-testid="nav-cta"
            className="rounded-full bg-[#2C3529] text-white px-6 py-2.5 font-sans text-sm font-medium hover:-translate-y-0.5 hover:bg-[#3a4636] transition-all duration-300"
          >
            Read the Journal
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#2C3529]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#EAE4D9] bg-[#FAF9F6] px-5 py-5 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-sans text-sm font-medium uppercase tracking-wider ${
                  isActive ? "text-[#D96B43]" : "text-[#2C3529]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}
